import { gql } from '@apollo/client';

export const STATS_ALL_TOURNAMENTS=gql`
    query ($first:Int, $page:Int $competicion_id:ID $active:Boolean){
        allTournaments(first:$first, page:$page, competicion_id:$competicion_id, active:$active){
            data{
                id,
                nombre,
                nombre_url,
                orden,
                competicion{
                    id,
                    nombre
                }
            },
            total_count
        }
    }
`;


export const STATS_GET_TOURNAMENT=gql`
    query ($id:ID!){
        getTournament(id:$id){
            id,
            id,
            nombre,
            nombre_url,
            orden,
            all_soccer_games{
                id,
                fecha,
                goles_local,
                goles_visitor,
                team_local{
                    id,
                    nombre,
                    nombre_estadio,
                    url_imagen_path
                },
                team_visitor{
                                id,
                    nombre,
                    nombre_estadio,
                    url_imagen_path  
                },
                round{
                    nombre,
                    abbr
                },
                tournament{
                    nombre
                },                
                extras{
                    boleto_url,
                    noticia_url,
                    clima_key,
                    arbitro_name,
                    tranmision_name,

                    date_open_park
                    date_open_doors
                    date_cupons_finish
                    date_game_start

                    txt_fan_fest
                    txt_prev
                    txt_zone_floor
                    txt_wingstop
                    txt_cupon_ayb
                    txt_cupon_halftime
                    txt_after
                    
                    daily_promo_concessions_id
                },
                pendiente,
            }
        }
    }
`;

export const STATS_GET_NEXT_GAME_BY_COMPETICION=gql`
query ($competicion_id:ID!){
    getNextGameByCompeticion(competicion_id:$competicion_id){
        id,
        fecha,
        goles_local,
        goles_visitor,
        round{
            nombre,
            abbr
        },
        tournament{
            nombre
        },
        team_local{
            id,
            nombre,
            nombre_estadio,
            url_imagen_path
        },
        team_visitor{
            id,
            nombre,
            nombre_estadio,
            url_imagen_path  
        },
        extras{
            boleto_url,
            noticia_url,
            clima_key,
            arbitro_name,
            tranmision_name,
            daily_promo_concessions_id
        },
        pendiente
    }
}
`;